import { render, staticRenderFns } from "./OptimizeTrigger.vue?vue&type=template&id=70cb2bef&scoped=true&"
import script from "./OptimizeTrigger.vue?vue&type=script&lang=js&"
export * from "./OptimizeTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cb2bef",
  null
  
)

export default component.exports